export default "__VITE_ASSET__Enl63lJK__"